import PropTypes from "prop-types"
import { Creators } from "model/profileModal"
import { IconButton } from "@mui/material"
import { OpenInNew } from "@mui/icons-material"
import { connect } from "react-redux"

function Factor({ factor, dispatch }) {
  const { id, label } = factor
  return <span className="factor">
    <IconButton size="small" onClick={() => dispatch(Creators.openFactorProfile(id))} title="Open factor profile"><OpenInNew className="factor-icon" /></IconButton>
    <span>{label}</span>
  </span>
}

Factor.propTypes = {
  factor: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  dispatch: PropTypes.func.isRequired,
}

// We need access to the redux store to dispatch the openFactorProfile action
export default connect(null, (dispatch) => ({ dispatch }))(Factor)
